import axios from 'axios';

// Create an Axios instance with default configurations
const instance = axios.create({
    baseURL: 'http://localhost:8080/api', // Replace with your backend base URL
    timeout: 10000, // Set a timeout of 10 seconds (optional)
    headers: {
        'Content-Type': 'application/json',
        // Add other default headers if needed, like Authorization
    },
});

// Export the instance to be used in other parts of your application
export default instance;